import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, setAuth } from "../lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

/* Handles the Emergent Google OAuth return: {origin}/...#session_id=...
 * Exchanges the session_id for our app JWT, then routes by role.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
 * THIS BREAKS THE AUTH.
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : "";

    // Clear the fragment so the session_id is never reused or bookmarked.
    window.history.replaceState(null, "", window.location.pathname + window.location.search);

    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }

    api.post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setAuth(data.token, data.user);
        toast.success(
          data.new_user
            ? `Welcome, ${data.user.name}! Your free trial is ready.`
            : `Welcome back, ${data.user.name}`
        );
        nav(data.user.role === "admin" ? "/admin" : "/seller/auto-listing", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed — please try again");
        nav("/login", { replace: true });
      });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-[#030712] text-white">
      <div className="text-center" data-testid="auth-callback-loading">
        <Loader2 size={32} className="animate-spin mx-auto text-indigo-400" />
        <div className="text-sm text-white/70 mt-4 font-semibold">Signing you in with Google…</div>
      </div>
    </div>
  );
}
